/* global axios */
const accountId = () => window.location.pathname.match(/accounts\/(\d+)/)?.[1] || 1;
const baseUrl = (taskId) => `/api/v1/accounts/${accountId()}/tasks/${taskId}/share`;

export default {
  generate(taskId) { return axios.post(baseUrl(taskId)); },
  revoke(taskId) { return axios.delete(baseUrl(taskId)); },
};
